import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation
} from 'react-router-dom';
import moa_logo from './assets/icons/moa_logo.png';
import helmsley_logo from './assets/icons/helmsley_logo.png';
import { DataProvider } from './data/DataContext';
import StatExplorer from './views/StatExplorer';
import RaceAndGender from './views/RaceAndGender';
import DataStories from './views/DataStories';
import Dashboards from './views/Dashboards';
import Comparisons from './views/Comparisons';
import MobileView from './views/MobileView';
import MoALogo from './assets/icons/MoALogo.svg';
import SCBLogo from './assets/icons/sbc/D2G_Logo.png';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useGlobalSelectedId, useStatusStoreNavigation, onSetCustomDB, onSetActiveGeography } from './data/StatusStore'; // Correct import path
import SearchPopup from './components/structure/SearchPopup'; // Correct import path
import { useData, FlatFileCsvData} from './data/DataContext';
import { useGlobalActiveIndicator, useGlobalBivariateIndicator, useGlobalActiveGeography, useGlobalCustomDB, onClickHistogram, onSetActivePage, onSetIsSmallScreen } from './data/StatusStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { update } from '@react-spring/web';
import { parseCustomDB } from './components/utilities/Utilities';
import SplashScreen from './components/structure/SplashScreen';
import BackToStoriesButton  from './components/structure/BackToStoriesButton';
import AboutScreen from './components/structure/AboutScreen';
import SpreadOutScreen from './components/structure/SpreadOutScreen';
import { sendPageview } from './components/utilities/ga';
import { siteConfig } from './config/siteConfig';

interface NavigationProps {
  setShowAbout: Function;
  indicatorOptions: any | null,
  groupedModules: any | null,
  groupedModulesRG: any | null,
  groupedModulesDashboard: any | null,
  groupedModulesStories: any | null,
  unGroupedModules: any | null,
  unGroupedModulesRG: any | null,
  unGroupedModulesDashboard: any | null,
  unGroupedModulesStories: any | null,
  allData: any | null,
  setAllData: (data: any) => void,
  setGroupedModules: (data: any) => void,
  setGroupedModulesRG: (data: any) => void,
  setGroupedModulesDashboard: (data: any) => void,
  setGroupedModulesStories: (data: any) => void,
  setUnGroupedModules: (data: any) => void,
  setUnGroupedModulesRG: (data: any) => void,
  setUnGroupedModulesDashboard: (data: any) => void,
  setUnGroupedModulesStories: (data: any) => void,
  setIndicatorOptions: (data: any) => void,
  searchData: any,
  setSearchData: (data: any) => void,
  setModuleIdIncrement: Function,
  moduleIdIncrement: number,
  toggleMenu: Function,
  setShowBackToStories: Function,
  showBackToStories: boolean,
  storySelected: string,
  setStorySelected: (story: string) => void,
}
function Navigation({ setShowAbout, indicatorOptions, groupedModules, groupedModulesRG, groupedModulesDashboard, groupedModulesStories, unGroupedModules, unGroupedModulesRG, unGroupedModulesDashboard, unGroupedModulesStories, 
  allData, setAllData, searchData, setSearchData, setIndicatorOptions, setGroupedModules, setGroupedModulesRG, setGroupedModulesDashboard, setGroupedModulesStories,
  setUnGroupedModules, setUnGroupedModulesRG, setUnGroupedModulesDashboard, setUnGroupedModulesStories,
  setModuleIdIncrement, moduleIdIncrement, toggleMenu, setShowBackToStories, showBackToStories, storySelected, setStorySelected
}: NavigationProps) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Initialize the StatusStore with navigation and location
  useStatusStoreNavigation();

  // Extract page from URL search parameters
  const searchParams = new URLSearchParams(location.search);
  const currentPage = searchParams.get('page') || 'explorer';
    
  const lastTrackedPageRef = useRef<string | null>(null);

  // GA4 page_view tracking based on ?page=
  useEffect(() => {
    console.log("A010726 showBackToStories", showBackToStories);
    console.log("A010726 currentPage", currentPage);
    console.log("A010726 lastTrackedPageRef.current", lastTrackedPageRef.current);
    // Only hide the "Back to Stories" button when the user navigates away
    // from the destination page (i.e. they didn't use the button, they just
    // kept browsing).  Never hide it on the first navigation FROM stories.
    if (showBackToStories){
      if (lastTrackedPageRef.current !== "stories" && currentPage === "stories"){ 
        setShowBackToStories(false);
      }
    }
    const page = currentPage || 'explorer';

    // Only send if GA is present and page actually changed
    if (typeof window === 'undefined') return;
    if (!window.gtag) return;

    if (lastTrackedPageRef.current === page) return;
    lastTrackedPageRef.current = page;

    // This will show up in GA as /explorer, /rg, /dashboard, etc.
    sendPageview(`/${page}`);
  }, [currentPage]);

  const { 
    dataActive, dataTract, dataNTA, dataPUMA, dataNYC, dataCD, dataBoro, isLoadingSorter, dataSorterOrder, dataSorterOrderRG, dataSorterOrderStories, dataSorterOrderDashboard,
    isLoadingTract, isLoadingNTA, isLoadingPUMA, isLoadingNYC, isLoadingCD, isLoadingBoro, isLoadingAllTabularData, dataSorter, dataSorterDashboard,
    error, pointDataList, setPointDataList, setPointModules } = useData();

  const activeGeography = useGlobalActiveGeography();
  const selectedId = useGlobalSelectedId();
  const customDB = useGlobalCustomDB();
  const [privateCustomDB, setPrivateCustomDB] = useState<string>(customDB);
  ////
  const [isMobile, setIsMobile] = useState(window.innerWidth < 950);
  const [childrenReady, setChildrenReady] = useState(0);
  const [parsedCustomDB, setParsedCustomDB] = useState<any>(null);
  const [initiatedCustomDB, setInitiatedCustomDB] = useState<boolean>(false);
  const [locked, setLocked] = useState<boolean>(false);
  const totalChildren = (currentPage === 'compare') 
      ? window.location.hostname === "localhost" ? 2 : 1
      : window.location.hostname === "localhost" ? 2 : 1;

  const handleChildReady = () => {
    //console.log("A113024 handleChildReady ");
    setChildrenReady((prev) => prev + 1);
  };

  useEffect(() => {
    //console.log("A113024 child ready childrenReady", childrenReady);
    //console.log("A113024 child ready totalChildren", totalChildren);
    if (childrenReady === totalChildren) {
      // All child components have rendered
      //console.log("101124 child ready selectedId", selectedId)
      const searchSelectedId = searchParams.get('selectedId') || siteConfig.defaults.selectedId;
      //console.log("101124 child ready searchSelectedId", searchSelectedId)
      onClickHistogram(searchSelectedId, "page_load", "N/A")
    }
  }, [childrenReady]);

  useEffect(() => {
      const handleResize = () => {
        onSetIsSmallScreen(window.innerWidth < 1350);
      };

      window.addEventListener('resize', handleResize);
      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  ////
  useEffect(() => {
    console.log("X102724 groupedModules",groupedModules);
  }, [groupedModules]);

  useEffect(() => {
    console.log("X102724 isLoadingAllTabularData",isLoadingAllTabularData);
  }, [isLoadingAllTabularData]);

  // Log the current page for debugging
  useEffect(() => {
    console.log("Current page:", currentPage);
  }, [currentPage]);

  useEffect(() => {
    console.log("A010926 allData", allData);
  }, [allData]);

  useEffect(() => {
    console.log("X102724 dataActive", dataActive);
  }, [dataActive]);

  function cleanString(input: string): string {
    let returnable = input
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, ''); // Remove all non-web-safe characters except hyphens
    //console.log("C102724 cleanString", input,">", returnable);
    return returnable;
  }

  useEffect(() => {
    //if (!isLoadingBoro && !isLoadingCD && !isLoadingNYC && !isLoadingPUMA && !isLoadingTract) {
    if (!isLoadingAllTabularData) {
        if (dataBoro && dataCD && dataNYC && dataPUMA && dataTract && dataNTA) {
            console.log("C100524 dataBoro", dataBoro);
            console.log("dataCD", dataCD);
            console.log("dataNYC", dataNYC);
            console.log("dataPUMA", dataPUMA);
            console.log("101924 dataTract", dataTract);
            console.log("B100524 dataNTA", dataNTA);
            let _indicatorOptions = [] as any;
            let _excludeOptions = ["", "DISPLAY_NAME"] as any;
            let testLimit = 0; 
            Object.keys(dataTract.meta.VARIABLE_NAME).forEach((i: string) => {
                //if (testLimit < 3){
                    //if (!_excludeOptions.includes(dataTract.meta.DISPLAY_NAME[i])){
                        _indicatorOptions.push(
                            { label: dataTract.meta.DISPLAY_NAME[i], value: i, type:"swarm" }
                        )
                    //    _indicatorOptions.push(
                    //        { label: dataTract.meta.DISPLAY_NAME[i], value: i, type:"histogram" }
                    //    )
                    //    testLimit++;
                    //}
                //}
                
            })
            setAllData({
                "Boro": dataBoro,
                "CD": dataCD,
                "NYC": dataNYC,
                "PUMA": dataPUMA,
                "Tract": dataTract,
                "NTA": dataNTA,
            });
            console.log("101924 _indicatorOptions", _indicatorOptions)
            setIndicatorOptions(_indicatorOptions)
        }
    }
}, [/*dataBoro, isLoadingBoro, dataCD, isLoadingCD, dataNYC, isLoadingNYC, dataPUMA, isLoadingPUMA, dataTract, isLoadingTract,*/ isLoadingAllTabularData]);

function getCurrentPage(): string {
  const params = new URLSearchParams(window.location.search);
  return params.get("page") || "home";
}

function getAvailGeos(item:any){
  //console.log("G050625 getAvailGeos item", item);
  return ({
    "Boro": item.Boro,
    "CD": item.CD,
    "NYC": item.NYC,
    "PUMA": item.PUMA,
    "Tract": item.Tract,
    "NTA": item.NTA,
  })

}
function disambiguateModuleId(moduleId:number, data:any, used:any){
    return moduleId;
    /*let _moduleId:string = moduleId.toString();
    let returnable = _moduleId;
    if (used.includes(_moduleId)){
      if (used.includes(_moduleId + "a")){
        if (used.includes(_moduleId + "b")){
          if (used.includes(_moduleId + "c")){
            returnable= _moduleId + "d";
          }else{
            returnable = _moduleId + "c";
          }
        }else{
          returnable = _moduleId + "b";
        }
      }else{
        returnable = moduleId + "a";
      }
    }else{
      returnable = _moduleId
    }
    console.log("DD101424 moduleId", _moduleId,">", returnable);
    //console.log("DD101424 data", data);
    console.log("DD101424 used", used);
    return returnable;*/
  }
  useEffect(() => {
    console.log("100724 dataActive", dataActive);
    console.log("100724 allData", allData);
    console.log("092924 isLoadingAllTabularData, isLoadingBoro, isLoadingCD, isLoadingNYC, isLoadingPUMA, isLoadingTract, isLoadingSorter", 
      isLoadingAllTabularData, isLoadingBoro, isLoadingCD, isLoadingNYC, isLoadingPUMA, isLoadingTract, isLoadingNTA, isLoadingSorter);
    console.log("092924 dataActive, dataSorter, Object.keys(dataActive).length > 0", dataActive, dataSorter, Object.keys(dataActive ? dataActive : {}).length > 0);
    let moduleId = 1;
    let usedModuleIds:any = [];
    if (!isLoadingAllTabularData) {  
      if (dataActive && dataSorter && Object.keys(dataActive).length > 0) {
        if (!locked){
          //////////////////////////////////////////////////////////////////////
          // RACE GENDER -- START
          //////////////////////////////////////////////////////////////////////
          let _indicatorOptionsRG = [] as any;
          let _pointModulesRG = {} as any;
          
          const groupedDataRG: any = {};
          const moduleDataRG: any = {};
          const preFlattenedModulesRG: any = {};

          dataSorter.forEach((_data:any) => {
            const data = { ..._data };
            //if (data.Module === "Point Data"){
            //  return;
            //}
            //console.log("B101924 data", data);
            let category = null;
            let subCategory = "";
            const module = data.Module || "Unknown";
            const shape = data.Shape || "Unknown";
            let sumTo100 = data["Sums to 100"] 
                ? data["Sums to 100"] !== "Ungrouped" 
                    ? data["Sums to 100"]
                    : data["Sums to 100"] 
                : "Ungrouped";
            sumTo100 = "Ungrouped"; // shape.toLowerCase() === "pyramid" ? "Ungrouped" : sumTo100; // TODO <-- research how this once allowed for multiple module types to participate at once (or other support it provided)
            data["moduleId"] = `${moduleId}a`; //disambiguateModuleId(moduleId, data, usedModuleIds);
            //console.log("B102524 category,subCategory,module)", category,subCategory,module)
            //console.log("B102524 dataSorterOrder", dataSorterOrder)

            moduleId++;
            if (!preFlattenedModulesRG[module]) {
              preFlattenedModulesRG[module] = {};
            }
        
            if (!preFlattenedModulesRG[module][sumTo100]) {
              preFlattenedModulesRG[module][sumTo100] = {};
            }
            if (!preFlattenedModulesRG[module][sumTo100][shape]) {
              preFlattenedModulesRG[module][sumTo100][shape] = [];
            }
            preFlattenedModulesRG[module][sumTo100][shape].push(data);
            moduleDataRG[data["Module"]] = data;
          });
          let _searchDataRG: any = {
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          };
          //let _searchDataDS: any = {
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          //};
          //let _searchDataDB: any = {
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          //};
          //let _searchDataAlgolia: any = [
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          //];
          //console.log("B101924 _searchData", _searchData);
          //console.log("D102824 groupedData", groupedData);
          //console.log("dataActive", dataActive);
          //console.log("L092924 dataActive.meta.VARIABLE_NAME", dataActive.meta.VARIABLE_NAME);
          //console.log("L092924 dataActive.meta", dataActive.meta);
          //console.log("102924 groupedData", groupedData);
          const flattenedModulesRG: any = preFlattenedModulesRG;

          /*console.log("103024 preFlattenedModules", preFlattenedModules);
          console.log("103024 flattenedModules", flattenedModules);
          console.log("103024 groupedData:", groupedData);
          console.log("102724 moduleData", moduleData);
          console.log("A112024 dataSorterOrder", dataSorterOrder);*/

          let lastCategoryRG = "";
          let makeHeaderRG = false;
          let orderOfAppearanceRG = 1;
          const uniqueDisplayNamesRG = new Set<string>();
          const lookupDisplayNamesRG: { [key: string]: any } = {};
          Object.keys(dataSorterOrderRG).forEach((category) => {
            if (category !== lastCategoryRG){
              //console.log("A112024 category", category);
              lastCategoryRG = category;
              makeHeaderRG = true;
            }
            console.log("A112024 category", category);
            console.log("A112024 dataSorterOrderRG", dataSorterOrderRG);
            Object.keys(dataSorterOrderRG[category]).forEach((subCategory) => {
              Object.keys(dataSorterOrderRG[category][subCategory]).forEach((module) => {
                //console.log("A112024 module", module);
                const uniqueModuleId = module;//dataSorterOrder[category][subCategory][module]["Unique Module ID"]
                const currentModuleId = dataSorterOrderRG[category][subCategory][module]["Current Module ID"]
                //const _order = orderOfAppearance; //dataSorterOrder[category][subCategory][module]["Order of appearance"]
                const _order = dataSorterOrderRG[category][subCategory][module]["Order of appearance"]
                const _sort = dataSorterOrderRG[category][subCategory][module]
                //console.log("GGG102624 uniqueModuleId", uniqueModuleId);
                //console.log("GGG102624 currentModuleId", currentModuleId);
                //console.log("K102624 +++++++++++++++ _order", _order);
                let _flatModuleData = {} as any;
                if (flattenedModulesRG[currentModuleId]){
                  _flatModuleData = JSON.parse(JSON.stringify(flattenedModulesRG[currentModuleId]));
                  if (Object.keys(_flatModuleData).length > 0){
                    //console.log("K102624 _flatModuleData",currentModuleId, _flatModuleData);
                    Object.keys(_flatModuleData).forEach((shape) => {
                      //console.log("K102624 ---------------",shape, _flatModuleData[shape]);
                      Object.keys(_flatModuleData[shape]).forEach((grouping) => {
                        if (grouping.toLowerCase() === "count"){
                          //console.log("XX121524 ---------------============",grouping, _flatModuleData[shape][grouping]);
                          _pointModulesRG[_flatModuleData[shape][grouping][0].DISPLAY_NAME] = _flatModuleData[shape][grouping];
                          _flatModuleData[shape][grouping].forEach((variable: any) => {
                            const displayName = variable.DISPLAY_NAME;
                            const variableName = variable.VARIABLE_NAME;
                            variable.Sort = _sort;
                            if (!_pointModulesRG[displayName]) {
                              _pointModulesRG[displayName] = {};
                            }

                            if (!_pointModulesRG[displayName][variableName]) {
                              _pointModulesRG[displayName][variableName] = [];
                            }

                            _pointModulesRG[displayName][variableName].push(variable);
                          });
                          _flatModuleData[shape][grouping].forEach((variable: any) => {
                            console.log("F012825 variable",variable);
                            uniqueDisplayNamesRG.add(variable.DISPLAY_NAME);
                            lookupDisplayNamesRG[variable.DISPLAY_NAME] = variable;
                          });
                        }
                        //console.log("Unique Display Names:", Array.from(uniqueDisplayNames));
                        _flatModuleData[shape][grouping] = _flatModuleData[shape][grouping].map((variable:any) => {
                          //console.log("K102624 ---------------============!!!!!!!!!!",variable);
                          _sort["Category_"] = category;
                          _sort["SubCategory_"] = subCategory;
                          const variableCopy = { ...variable };
                          variableCopy.Order = _order;
                          variableCopy.Sort = _sort;
                          variableCopy.moduleId = cleanString(uniqueModuleId);
                          return variableCopy;
                        });
                      });
                    });
                    
                  }else{
                    console.log("K102624 MISSING ------------------------------------");
                    console.log("K102624 uniqueModuleId", uniqueModuleId);
                    console.log("K102624 currentModuleId", currentModuleId);
                    console.log("K102624 --------------------------------------------");
                  }
                }else{
                  console.log("K102624 MISSING ------------------------------------");
                  console.log("K102624 uniqueModuleId", uniqueModuleId);
                  console.log("K102624 currentModuleId", currentModuleId);
                  console.log("K102624 --------------------------------------------");
                }
                //console.log("F102824 _flatModuleData ~~~~~~~~~~~~~",currentModuleId, _flatModuleData);
                if (makeHeaderRG){
                  makeHeaderRG = false;
                  console.log("G102824 makeHeader category",category);
                  console.log("G102824 makeHeader _flatModuleData",_flatModuleData);
                  let COPIED_flatModuleData = JSON.parse(JSON.stringify(_flatModuleData));
                  let NEW_flatModuleData:any = {};
                  console.log("G102824 makeHeader COPIED_flatModuleData",COPIED_flatModuleData);
                  if (Object.keys(COPIED_flatModuleData).length > 0) {
                    let COPY_COPY = [JSON.parse(JSON.stringify(COPIED_flatModuleData[Object.keys(COPIED_flatModuleData)[0]][Object.keys(COPIED_flatModuleData[Object.keys(COPIED_flatModuleData)[0]])[0]]))[0]];
                    COPY_COPY[0].Shape = "category header";
                    COPY_COPY[0].Order = "0";
                    COPY_COPY[0].Tract = "X";
                    COPY_COPY[0].CD = "X";
                    COPY_COPY[0].PUMA = "X";
                    COPY_COPY[0].NYC = "X";
                    COPY_COPY[0].NTA = "X";
                    COPY_COPY[0].POINT = "X";
                    COPY_COPY[0].Boro = "X";

                    NEW_flatModuleData["Ungrouped"] = {"category header" : COPY_COPY};
                  }
                  console.log("A012125 makeHeader NEW_flatModuleData",NEW_flatModuleData);
                  dataSorterOrderRG[category][subCategory][`${cleanString(category)}-header`] = NEW_flatModuleData;
                }
                //console.log("J121624 _flatModuleData",_flatModuleData);
                dataSorterOrderRG[category][subCategory][uniqueModuleId] = _flatModuleData;
                orderOfAppearanceRG++;
              });
            });
          });
          console.log("G102824 dataSorterOrderRG", dataSorterOrderRG);
          console.log("D102524 groupedDataRG", groupedDataRG);
          //console.log("D102524 _indicatorOptions", _indicatorOptions);
          let _unGroupedModulesRG = {} as any;
          const processArraysInJSONRG = (obj: any, callback: (arr: any[]) => void): void => {
            for (const key in obj) {
              if (Array.isArray(obj[key])) {
                // If the property is an array, execute the callback function on it
                callback(obj[key]);
              } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                // If the property is an object, recursively process it
                processArraysInJSONRG(obj[key], callback);
              }
            }
          };
      
          // Call the function on `dataSorterOrder` with a callback to log each array
          processArraysInJSONRG(dataSorterOrderRG, (arr) => {
            //console.log("110324 Array found:", arr);
            _unGroupedModulesRG[arr[0].moduleId] = arr;
            arr.forEach(item => {
              //console.log("B032825 Array item:", item);
              /*_searchDataAlgolia.push(
                { 
                  search:`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`, 
                  directive: "explorer", 
                  data: item["VARIABLE_NAME"], 
                  directive_data: item["moduleId"] 
                }
              );*/
              if (item.Module !== "not used"){
                let _item = { directive: "explorer", data: item["VARIABLE_NAME"], directive_data: item["moduleId"], availableGeos: getAvailGeos(item) }
                _searchDataRG[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`] 
                    ? _searchDataRG[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`].push(_item)
                    : _searchDataRG[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`] = [_item]
              }
            });
          });

          console.log("F092524 _indicatorOptionsRG", _indicatorOptionsRG);
          //console.log("YYY102724 groupedData", groupedData);
          console.log("030125 _searchDataRG",_searchDataRG);
          //console.log("030125 _searchDataAlgolia",_searchDataAlgolia);
          //console.log("030125 JSON.stringify(_searchDataAlgolia)",JSON.stringify(_searchDataAlgolia));
          console.log("B012825 groupedDataRG",groupedDataRG);
          //setSearchData(_searchData);
          //setIndicatorOptions(_indicatorOptionsRG)
          //setGroupedModules(groupedData);
          
          console.log("121524 groupedDataRG", groupedDataRG);
          //console.log("121524 pointDataList", pointDataList);
          //console.log("121524 setPointDataList", setPointDataList);
          console.log("F012825 uniqueDisplayNamesRG", uniqueDisplayNamesRG);
          console.log("A012125 _unGroupedModulesRG", _unGroupedModulesRG);
          setUnGroupedModulesRG({..._unGroupedModulesRG});

          setGroupedModulesRG({...dataSorterOrderRG});
          //setPointDataList(Array.from(uniqueDisplayNames));
          //setPointModules(_pointModules);

          //////////////////////////////////////////////////////////////////////
          // RACE GENDER -- END
          //////////////////////////////////////////////////////////////////////
          //////////////////////////////////////////////////////////////////////
          // STAT EXPLORER -- START
          //////////////////////////////////////////////////////////////////////
          let _indicatorOptions = [] as any;
          let _pointModules = {} as any;
          
          const groupedData: any = {};
          const moduleData: any = {};
          const preFlattenedModules: any = {};
          
          dataSorter.forEach((_data:any) => {
            const data = { ..._data };
            //if (data.Module === "Point Data"){
            //  return;
            //}
            //console.log("B101924 data", data);
            let category = null;
            let subCategory = "";
            const module = data.Module || "Unknown";
            const shape = data.Shape || "Unknown";
            let sumTo100 = data["Sums to 100"] 
                ? data["Sums to 100"] !== "Ungrouped" 
                    ? data["Sums to 100"]
                    : data["Sums to 100"] 
                : "Ungrouped";
            sumTo100 = "Ungrouped"; // shape.toLowerCase() === "pyramid" ? "Ungrouped" : sumTo100; // TODO <-- research how this once allowed for multiple module types to participate at once (or other support it provided)
            data["moduleId"] = `${moduleId}a`; //disambiguateModuleId(moduleId, data, usedModuleIds);
            //console.log("B102524 category,subCategory,module)", category,subCategory,module)
            //console.log("B102524 dataSorterOrder", dataSorterOrder)

            moduleId++;
            if (!preFlattenedModules[module]) {
              preFlattenedModules[module] = {};
            }
        
            if (!preFlattenedModules[module][sumTo100]) {
              preFlattenedModules[module][sumTo100] = {};
            }
            if (!preFlattenedModules[module][sumTo100][shape]) {
              preFlattenedModules[module][sumTo100][shape] = [];
            }
            preFlattenedModules[module][sumTo100][shape].push(data);
            moduleData[data["Module"]] = data;
          });
          let _searchData: any = {
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          };
          let _searchDataDS: any = {
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          };
          let _searchDataDB: any = {
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          };
          //let _searchDataAlgolia: any = [
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          //];
          //console.log("B101924 _searchData", _searchData);
          //console.log("D102824 groupedData", groupedData);
          //console.log("dataActive", dataActive);
          //console.log("L092924 dataActive.meta.VARIABLE_NAME", dataActive.meta.VARIABLE_NAME);
          //console.log("L092924 dataActive.meta", dataActive.meta);
          //console.log("102924 groupedData", groupedData);
          const flattenedModules: any = preFlattenedModules;

          /*console.log("103024 preFlattenedModules", preFlattenedModules);
          console.log("103024 flattenedModules", flattenedModules);
          console.log("103024 groupedData:", groupedData);
          console.log("102724 moduleData", moduleData);
          console.log("A112024 dataSorterOrder", dataSorterOrder);*/

          let lastCategory = "";
          let makeHeader = false;
          let orderOfAppearance = 1;
          const uniqueDisplayNames = new Set<string>();
          const lookupDisplayNames: { [key: string]: any } = {};
          Object.keys(dataSorterOrder).forEach((category) => {
            if (category !== lastCategory){
              //console.log("A112024 category", category);
              lastCategory = category;
              makeHeader = true;
            }
            console.log("A112024 category", category);
            console.log("A112024 dataSorterOrder", dataSorterOrder);
            Object.keys(dataSorterOrder[category]).forEach((subCategory) => {
              Object.keys(dataSorterOrder[category][subCategory]).forEach((module, index) => {
                const uniqueModuleId = module;//dataSorterOrder[category][subCategory][module]["Unique Module ID"]
                const currentModuleId = dataSorterOrder[category][subCategory][module]["Current Module ID"]
                //const _order = orderOfAppearance; //dataSorterOrder[category][subCategory][module]["Order of appearance"]
                const _order = dataSorterOrder[category][subCategory][module]["Order of appearance"]
                const _sort = dataSorterOrder[category][subCategory][module]
                //console.log("GGG102624 uniqueModuleId", uniqueModuleId);
                //console.log("GGG102624 currentModuleId", currentModuleId);
                //console.log("K102624 +++++++++++++++ _order", _order);
                let _flatModuleData = {} as any;
                if (flattenedModules[currentModuleId]){
                  _flatModuleData = JSON.parse(JSON.stringify(flattenedModules[currentModuleId]));
                  if (Object.keys(_flatModuleData).length > 0){
                    //console.log("K102624 _flatModuleData",currentModuleId, _flatModuleData);
                    Object.keys(_flatModuleData).forEach((shape) => {
                      //console.log("K102624 ---------------",shape, _flatModuleData[shape]);
                      Object.keys(_flatModuleData[shape]).forEach((grouping) => {
                        if (grouping.toLowerCase() === "count"){
                          //console.log("XX121524 ---------------============",grouping, _flatModuleData[shape][grouping]);
                          //_pointModules[_flatModuleData[shape][grouping][0].DISPLAY_NAME] = _flatModuleData[shape][grouping];
                          _flatModuleData[shape][grouping].forEach((variable: any) => {
                            const displayName = variable.DISPLAY_NAME;
                            const variableName = variable.VARIABLE_NAME;
                            variable.Sort = _sort;
                            if (!_pointModules[displayName]) {
                              _pointModules[displayName] = {};
                            }

                            if (!_pointModules[displayName][variableName]) {
                              _pointModules[displayName][variableName] = [];
                            }

                            _pointModules[displayName][variableName].push(variable);
                          });
                          _flatModuleData[shape][grouping].forEach((variable: any) => {
                            //console.log("F012825 variable",variable);
                            uniqueDisplayNames.add(variable.DISPLAY_NAME);
                            lookupDisplayNames[variable.DISPLAY_NAME] = variable;
                          });
                        }
                        //console.log("Unique Display Names:", Array.from(uniqueDisplayNames));
                        _flatModuleData[shape][grouping] = _flatModuleData[shape][grouping].map((variable:any) => {
                          //console.log("K102624 ---------------============!!!!!!!!!!",variable);
                          _sort["Category_"] = category;
                          _sort["SubCategory_"] = subCategory;
                          const variableCopy = { ...variable };
                          variableCopy.Order = _order;
                          variableCopy.Sort = _sort;
                          variableCopy.moduleId = cleanString(uniqueModuleId);
                          return variableCopy;
                        });
                      });
                    });
                    
                  }else{
                    console.log("K102624 MISSING ------------------------------------");
                    console.log("K102624 uniqueModuleId", uniqueModuleId);
                    console.log("K102624 currentModuleId", currentModuleId);
                    console.log("K102624 --------------------------------------------");
                  }
                }else{
                  console.log("K102624 MISSING ------------------------------------");
                  console.log("K102624 uniqueModuleId", uniqueModuleId);
                  console.log("K102624 currentModuleId", currentModuleId);
                  console.log("K102624 --------------------------------------------");
                }

                if (makeHeader){
                  makeHeader = false;
                  console.log("G102824 makeHeader category",category);
                  console.log("G102824 makeHeader _flatModuleData",_flatModuleData);
                  let COPIED_flatModuleData = JSON.parse(JSON.stringify(_flatModuleData));
                  let NEW_flatModuleData:any = {};
                  console.log("G102824 makeHeader COPIED_flatModuleData",COPIED_flatModuleData);
                  if (Object.keys(COPIED_flatModuleData).length > 0) {
                    let COPY_COPY = [JSON.parse(JSON.stringify(COPIED_flatModuleData[Object.keys(COPIED_flatModuleData)[0]][Object.keys(COPIED_flatModuleData[Object.keys(COPIED_flatModuleData)[0]])[0]]))[0]];
                    COPY_COPY[0].Shape = "category header";
                    COPY_COPY[0].Order = "0";
                    COPY_COPY[0].Tract = "X";
                    COPY_COPY[0].CD = "X";
                    COPY_COPY[0].PUMA = "X";
                    COPY_COPY[0].NYC = "X";
                    COPY_COPY[0].NTA = "X";
                    COPY_COPY[0].POINT = "X";
                    COPY_COPY[0].Boro = "X";

                    NEW_flatModuleData["Ungrouped"] = {"category header" : COPY_COPY};
                  }
                  console.log("A012125 makeHeader NEW_flatModuleData",NEW_flatModuleData);
                  dataSorterOrder[category][subCategory][`${cleanString(category)}-header`] = NEW_flatModuleData;
                  //dataSorterOrder[category][subCategory][`${cleanString(category)}-header3`] = NEW_flatModuleData;
                }

                dataSorterOrder[category][subCategory][uniqueModuleId] = _flatModuleData;
                orderOfAppearance++;                
                if (_flatModuleData.Ungrouped?.beeswarm && siteConfig.ctx === "sbc"){
                  //console.log("A042326 _flatModuleData",_flatModuleData);
                  let rangeSwarm_flatModuleData = JSON.parse(JSON.stringify(_flatModuleData));
                  
                  rangeSwarm_flatModuleData.Ungrouped['range beeswarm'] = rangeSwarm_flatModuleData.Ungrouped.beeswarm;
                  delete rangeSwarm_flatModuleData.Ungrouped.beeswarm;
                  rangeSwarm_flatModuleData.Ungrouped['range beeswarm'][0].Shape = "range beeswarm";
                  rangeSwarm_flatModuleData.Ungrouped['range beeswarm'][0].Sort["Module Title"] = rangeSwarm_flatModuleData.Ungrouped['range beeswarm'][0].Sort["Module Title"] + " - range beeswarm";
                  console.log("A042326 rangeSwarm_flatModuleData",rangeSwarm_flatModuleData);
                  dataSorterOrder[category][subCategory][uniqueModuleId + "_2"] = rangeSwarm_flatModuleData;
                  orderOfAppearance++;  
                }
              });
            });
          });
          //console.log("A121125 dataSorterOrder", dataSorterOrder);
          //console.log("A121125 groupedData", groupedData);
          //console.log("D102524 _indicatorOptions", _indicatorOptions);
          Object.keys(dataSorterOrder).forEach((category) => {
            Object.keys(dataSorterOrder[category]).forEach((subCategory) => {
              Object.keys(dataSorterOrder[category][subCategory]).forEach((module) => {
                //console.log("A121125 category", category);
                //console.log("A121125 subCategory", subCategory);
                //console.log("A121125 module", module);
                //console.log("A121125 module == ", dataSorterOrder[category][subCategory][module]);
                // Find and log only the module with the highest Order within the current category
                const getOrder = (modObj: any): number => {
                  if (!modObj || typeof modObj !== 'object') return -Infinity;
                  const firstShape = Object.keys(modObj)[0];
                  if (!firstShape) return -Infinity;
                  const firstGrouping = Object.keys(modObj[firstShape] || {})[0];
                  const arr = modObj[firstShape]?.[firstGrouping];
                  const rawOrder = Array.isArray(arr) && arr[0]?.Order;
                  const numOrder = typeof rawOrder === 'string' ? parseFloat(rawOrder) : rawOrder;
                  return Number.isFinite(numOrder) ? numOrder : -Infinity;
                };

                // Compute the max order across all modules in this category
                const maxOrderInCategory = (() => {
                  let max = -Infinity;
                  Object.keys(dataSorterOrder[category]).forEach((sc) => {
                  Object.keys(dataSorterOrder[category][sc]).forEach((m) => {
                    const ord = getOrder(dataSorterOrder[category][sc][m]);
                    if (ord > max) max = ord;
                  });
                  });
                  return max;
                })();

                // Ensure we only log once per category
                (dataSorterOrder as any).__loggedCategories ||= new Set<string>();

                const currentOrder = getOrder(dataSorterOrder[category][subCategory][module]);
                if (currentOrder === maxOrderInCategory && !(dataSorterOrder as any).__loggedCategories.has(category)) {
                      // Create and inject a category footer based on the highest-order module in this category
                      try {
                      const COPIED_flatModuleData = JSON.parse(
                        JSON.stringify(dataSorterOrder[category][subCategory][module])
                      );
                      const NEW_flatModuleData: any = {};
                      if (Object.keys(COPIED_flatModuleData).length > 0) {
                        const firstShape = Object.keys(COPIED_flatModuleData)[0];
                        const firstGrouping =
                        Object.keys(COPIED_flatModuleData[firstShape] || {})[0];
                        const exemplarArr =
                        COPIED_flatModuleData[firstShape]?.[firstGrouping];
                        if (Array.isArray(exemplarArr) && exemplarArr.length > 0) {
                        const COPY_COPY = [JSON.parse(JSON.stringify(exemplarArr[0]))];
                        COPY_COPY[0].Shape = "category footer";
                        COPY_COPY[0].Order = Number.isFinite(maxOrderInCategory)
                          ? String(maxOrderInCategory + 1)
                          : "0";
                        COPY_COPY[0].Tract = "X";
                        COPY_COPY[0].CD = "X";
                        COPY_COPY[0].PUMA = "X";
                        COPY_COPY[0].NYC = "X";
                        COPY_COPY[0].NTA = "X";
                        COPY_COPY[0].POINT = "X";
                        COPY_COPY[0].Boro = "X";
                        NEW_flatModuleData["Ungrouped"] = { "category footer": COPY_COPY };
                        }
                      }
                      dataSorterOrder[category][subCategory][`${cleanString(category)}-footer`] =
                        NEW_flatModuleData;
                      } catch (e) {
                        console.warn("Failed to create category footer:", e);
                      }
                  (dataSorterOrder as any).__loggedCategories.add(category);
                  
                }
              });
            });
          });
          console.log("A121125 dataSorterOrder", dataSorterOrder);
          console.log("A121125 groupedData", groupedData);
          let _unGroupedModules = {} as any;
          const processArraysInJSON = (obj: any, callback: (arr: any[]) => void): void => {
            for (const key in obj) {
              if (Array.isArray(obj[key])) {
                // If the property is an array, execute the callback function on it
                callback(obj[key]);
              } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                // If the property is an object, recursively process it
                processArraysInJSON(obj[key], callback);
              }
            }
          };
      
          // Call the function on `dataSorterOrder` with a callback to log each array
          processArraysInJSON(dataSorterOrder, (arr) => {
            //console.log("110324 Array found:", arr);
            _unGroupedModules[arr[0].moduleId] = arr;
            arr.forEach(item => {
              //console.log("B032825 Array item:", item);
              /*_searchDataAlgolia.push(
                { 
                  search:`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`, 
                  directive: "explorer", 
                  data: item["VARIABLE_NAME"], 
                  directive_data: item["moduleId"] 
                }
              );*/
              if (item.Module !== "not used"){
                let _item = { directive: "explorer", data: item["VARIABLE_NAME"], directive_data: item["moduleId"], availableGeos: getAvailGeos(item) }
                _searchData[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`] 
                    ? _searchData[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`].push(_item)
                    : _searchData[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`] = [_item]
              }
            });
          });

          console.log("F092524 _indicatorOptions", _indicatorOptions);
          //console.log("YYY102724 groupedData", groupedData);
          console.log("030125 _searchData",_searchData);
          //console.log("030125 _searchDataAlgolia",_searchDataAlgolia);
          //console.log("030125 JSON.stringify(_searchDataAlgolia)",JSON.stringify(_searchDataAlgolia));
          console.log("B012825 groupedData",groupedData);
          //setSearchData(_searchData);
          setIndicatorOptions(_indicatorOptions)
          //setGroupedModules(groupedData);
          
          console.log("121524 groupedData", groupedData);
          console.log("121524 pointDataList", pointDataList);
          console.log("121524 setPointDataList", setPointDataList);
          console.log("F012825 uniqueDisplayNames", uniqueDisplayNames);
          console.log("A012125 _unGroupedModules", _unGroupedModules);
          setUnGroupedModules({..._unGroupedModules});

          setGroupedModules({...dataSorterOrder});
          setPointDataList(Array.from(uniqueDisplayNames));
          setPointModules(_pointModules);

          //////////////////////////////////////////////////////////////////////
          // STAT EXPLORER -- END
          //////////////////////////////////////////////////////////////////////
          ///////////////////////
          // DATA STORIES  --  START
          ///////////////////////

          let lastCategoryDS = "";
          let makeHeaderDS = false;
          let orderOfAppearanceDS = 1;
          const uniqueDisplayNamesDS = new Set<string>();
          const lookupDisplayNamesDS: { [key: string]: any } = {};
          console.log("A031125 dataSorterOrderStories", dataSorterOrderStories);
          Object.keys(dataSorterOrderStories).forEach((category) => {
            if (category !== lastCategoryDS){
              //console.log("A112024 category", category);
              lastCategoryDS = category;
              makeHeaderDS = true;
            }
            Object.keys(dataSorterOrderStories[category]).forEach((subCategory) => {
              Object.keys(dataSorterOrderStories[category][subCategory]).forEach((module) => {
                //console.log("A112024 module", module);
                const uniqueModuleId = module;//dataSorterOrderStories[category][subCategory][module]["Unique Module ID"]
                const currentModuleId = dataSorterOrderStories[category][subCategory][module]["Current Module ID"]
                //const _order = orderOfAppearanceDS; //dataSorterOrderStories[category][subCategory][module]["Order of appearance"]
                const _order = dataSorterOrderStories[category][subCategory][module]["Order of appearance"]
                const _sort = dataSorterOrderStories[category][subCategory][module]
                //console.log("GGG102624 uniqueModuleId", uniqueModuleId);
                //console.log("GGG102624 currentModuleId", currentModuleId);
                //console.log("K102624 +++++++++++++++ _order", _order);
                let _flatModuleData = {} as any;
                if (flattenedModules[currentModuleId]){
                  _flatModuleData = JSON.parse(JSON.stringify(flattenedModules[currentModuleId]));
                  if (Object.keys(_flatModuleData).length > 0){
                    //console.log("K102624 _flatModuleData",currentModuleId, _flatModuleData);
                    Object.keys(_flatModuleData).forEach((shape) => {
                      //console.log("K102624 ---------------",shape, _flatModuleData[shape]);
                      Object.keys(_flatModuleData[shape]).forEach((grouping) => {
                        if (grouping.toLowerCase() === "count"){
                          //console.log("XX121524 ---------------============",grouping, _flatModuleData[shape][grouping]);
                          //_pointModules[_flatModuleData[shape][grouping][0].DISPLAY_NAME] = _flatModuleData[shape][grouping];
                          _flatModuleData[shape][grouping].forEach((variable: any) => {
                            const displayName = variable.DISPLAY_NAME;
                            const variableName = variable.VARIABLE_NAME;
                            variable.Sort = _sort;
                            if (!_pointModules[displayName]) {
                              _pointModules[displayName] = {};
                            }

                            if (!_pointModules[displayName][variableName]) {
                              _pointModules[displayName][variableName] = [];
                            }

                            _pointModules[displayName][variableName].push(variable);
                          });
                          _flatModuleData[shape][grouping].forEach((variable: any) => {
                            console.log("F012825 variable",variable);
                            uniqueDisplayNamesDS.add(variable.DISPLAY_NAME);
                            lookupDisplayNamesDS[variable.DISPLAY_NAME] = variable;
                          });
                        }
                        //console.log("Unique Display Names:", Array.from(uniqueDisplayNamesDS));
                        _flatModuleData[shape][grouping] = _flatModuleData[shape][grouping].map((variable:any) => {
                          //console.log("K102624 ---------------============!!!!!!!!!!",variable);
                          _sort["Category_"] = category;
                          _sort["SubCategory_"] = subCategory;
                          const variableCopy = { ...variable };
                          variableCopy.Order = _order;
                          variableCopy.Sort = _sort;
                          variableCopy.moduleId = cleanString(uniqueModuleId);
                          return variableCopy;
                        });
                      });
                    });
                    
                  }else{
                    console.log("K102624 MISSING ------------------------------------");
                    console.log("K102624 uniqueModuleId", uniqueModuleId);
                    console.log("K102624 currentModuleId", currentModuleId);
                    console.log("K102624 --------------------------------------------");
                  }
                }else{
                  console.log("K102624 MISSING ------------------------------------");
                  console.log("K102624 uniqueModuleId", uniqueModuleId);
                  console.log("K102624 currentModuleId", currentModuleId);
                  console.log("K102624 --------------------------------------------");
                }
                //console.log("F102824 _flatModuleData ~~~~~~~~~~~~~",currentModuleId, _flatModuleData);
                /*if (makeHeaderDS){
                  makeHeaderDS = false;
                  console.log("G102824 makeHeaderDS category",category);
                  console.log("G102824 makeHeaderDS _flatModuleData",_flatModuleData);
                  let COPIED_flatModuleData = JSON.parse(JSON.stringify(_flatModuleData));
                  let NEW_flatModuleData:any = {};
                  console.log("G102824 makeHeaderDS COPIED_flatModuleData",COPIED_flatModuleData);
                  if (Object.keys(COPIED_flatModuleData).length > 0) {
                    let COPY_COPY = [JSON.parse(JSON.stringify(COPIED_flatModuleData[Object.keys(COPIED_flatModuleData)[0]][Object.keys(COPIED_flatModuleData[Object.keys(COPIED_flatModuleData)[0]])[0]]))[0]];
                    COPY_COPY[0].Shape = "category header";
                    COPY_COPY[0].Order = "0";
                    COPY_COPY[0].Tract = "X";
                    COPY_COPY[0].CD = "X";
                    COPY_COPY[0].PUMA = "X";
                    COPY_COPY[0].NYC = "X";
                    COPY_COPY[0].NTA = "X";
                    COPY_COPY[0].POINT = "X";
                    COPY_COPY[0].Boro = "X";

                    NEW_flatModuleData["Ungrouped"] = {"category header" : COPY_COPY};
                  }
                  console.log("A012125 makeHeaderDS NEW_flatModuleData",NEW_flatModuleData);
                  dataSorterOrderStories[category][subCategory][`${cleanString(category)}-header`] = NEW_flatModuleData;
                }*/
                //console.log("J121624 _flatModuleData",_flatModuleData);
                dataSorterOrderStories[category][subCategory][uniqueModuleId] = _flatModuleData;
                orderOfAppearanceDS++;
              });
            });
          });
          console.log("G102824 dataSorterOrderStories", dataSorterOrderStories);
          console.log("D102524 groupedData", groupedData);
          //console.log("D102524 _indicatorOptions", _indicatorOptions);
          let _unGroupedModulesDS = {} as any;
          const processArraysInJSONDS = (obj: any, callback: (arr: any[]) => void): void => {
            for (const key in obj) {
              if (Array.isArray(obj[key])) {
                // If the property is an array, execute the callback function on it
                callback(obj[key]);
              } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                // If the property is an object, recursively process it
                processArraysInJSONDS(obj[key], callback);
              }
            }
          };
      
          // Call the function on `dataSorterOrderStories` with a callback to log each array
          processArraysInJSONDS(dataSorterOrderStories, (arr) => {
            //console.log("110324 Array found:", arr);
            _unGroupedModules[arr[0].moduleId] = arr;
            arr.forEach(item => {
              //console.log("110324 Array item:", item);
              /*_searchDataAlgolia.push(
                { 
                  search:`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`, 
                  directive: "stories", 
                  data: item["VARIABLE_NAME"], 
                  directive_data: item["moduleId"] 
                }
              );*/
              if (item.Module !== "not used"){
                let _item = { directive: "stories", data: item["VARIABLE_NAME"], directive_data: item["moduleId"], availableGeos: getAvailGeos(item) };
                _searchDataDS[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`] 
                    ? _searchDataDS[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`].push(_item)
                    : _searchDataDS[`${item.Sort.SubCategory_} - ${item["DISPLAY_NAME"]}`] = [_item]
              }
            });
          });

          console.log("F092524 _indicatorOptions", _indicatorOptions);
          //console.log("YYY102724 groupedData", groupedData);
          console.log("A032825 _searchDataDS",_searchDataDS);
          //console.log("030125 _searchDataAlgolia",_searchDataAlgolia);
          //console.log("030125 JSON.stringify(_searchDataAlgolia)",JSON.stringify(_searchDataAlgolia));
          console.log("B012825 groupedData",groupedData);
          //setSearchData(_searchData);
          //setIndicatorOptions(_indicatorOptions)
          //setGroupedModules(groupedData);
          
          console.log("121524 groupedData", groupedData);
          console.log("121524 pointDataList", pointDataList);
          console.log("121524 setPointDataList", setPointDataList);
          console.log("F012825 uniqueDisplayNamesDS", uniqueDisplayNamesDS);
          console.log("A012125 _unGroupedModules", _unGroupedModules);
          setUnGroupedModulesStories({..._unGroupedModules});

          setGroupedModulesStories({...dataSorterOrderStories});
          //setPointDataList(Array.from(uniqueDisplayNamesDS));
          //setPointModules(_pointModules);

          ///////////////////////
          // DATA STORIES  --  END
          ///////////////////////

          //////////////////////////////////////////////////////////////////////
          // DASHBOARDS
          //////////////////////////////////////////////////////////////////////

          let _indicatorOptionsDashboard = [] as any;
          
          const groupedDataDashboard: any = {};
          const moduleDataDashboard: any = {};
          const preFlattenedModulesDashboard: any = {};
          console.log("A012325 dataSorterDashboard", dataSorterDashboard);
          dataSorterDashboard.forEach((_data:any) => {
            const data = { ..._data };
            if (data.Module === "Point Data"){
              return;
            }
            //console.log("B101924 data", data);
            let category = null;
            let subCategory = "";
            const module = data.Module || "Unknown";
            const shape = data.Shape || "Unknown";
            let sumTo100 = data["Sums to 100"] 
                ? data["Sums to 100"] !== "Ungrouped" 
                    ? data["Sums to 100"]
                    : data["Sums to 100"] 
                : "Ungrouped";
            sumTo100 = "Ungrouped"; //shape.toLowerCase() === "pyramid" ? "Ungrouped" : sumTo100; TODO <-- research how this once allowed for multiple module types to participate at once (or other support it provided)
            data["moduleId"] = `${moduleId}a`; //disambiguateModuleId(moduleId, data, usedModuleIds);
            //console.log("B102524 category,subCategory,module)", category,subCategory,module)
            //console.log("B102524 dataSorterOrderDashboard", dataSorterOrderDashboard)

            moduleId++;
            if (!preFlattenedModulesDashboard[module]) {
              preFlattenedModulesDashboard[module] = {};
            }
        
            if (!preFlattenedModulesDashboard[module][sumTo100]) {
              preFlattenedModulesDashboard[module][sumTo100] = {};
            }
            if (!preFlattenedModulesDashboard[module][sumTo100][shape]) {
              preFlattenedModulesDashboard[module][sumTo100][shape] = [];
            }
            preFlattenedModulesDashboard[module][sumTo100][shape].push(data);
            moduleDataDashboard[data["Module"]] = data;
            

          });
          console.log("A012325 preFlattenedModulesDashboard", preFlattenedModulesDashboard) // Age.Ungrouped.pyramid[2]["Role Order"]
          //let _searchDataDashboard: any = {
            // 'search string': { directive: "what to do with this when clicked", data: "Some data about the search string" },
            //'Cholesterol screening': [{ directive: "explorer", data: "cholesterol_screening_cdc", directive_data: "174a" },
          //};
          //console.log("B101924 _searchDataDashboard", _searchDataDashboard);
          console.log("D102824 groupedDataDashboard", groupedDataDashboard);
          console.log("dataActive", dataActive);
          //console.log("L092924 dataActive.meta.VARIABLE_NAME", dataActive.meta.VARIABLE_NAME);
          //console.log("L092924 dataActive.meta", dataActive.meta);
          console.log("102924 groupedDataDashboard", groupedDataDashboard);
          const flattenedModulesDashboard: any = preFlattenedModulesDashboard;

          console.log("103024 preFlattenedModulesDashboard", preFlattenedModulesDashboard);
          console.log("103024 flattenedModulesDashboard", flattenedModulesDashboard);
          console.log("103024 groupedDataDashboard:", groupedDataDashboard);
          console.log("102724 moduleDataDashboard", moduleDataDashboard);
          console.log("102724 dataSorterOrderDashboard", dataSorterOrderDashboard);

          let lastCategoryDashboard = "";
          let makeHeaderDashboard = false;
          let orderOfAppearanceDashboard = 1;
          Object.keys(dataSorterOrderDashboard).forEach((category) => {
            if (category !== lastCategoryDashboard){
              //console.log("F102824 category", category);
              lastCategoryDashboard = category;
              //makeHeaderDashboard = true; // DONT MAKE DASHBOARD HEADERS
            }
            //console.log("D110424 dataSorterOrderDashboard", dataSorterOrderDashboard);
            Object.keys(dataSorterOrderDashboard[category]).forEach((subCategory) => {
              Object.keys(dataSorterOrderDashboard[category][subCategory]).forEach((module) => {
                //console.log("D110424 module", module);
                const uniqueModuleId = module;//dataSorterOrderDashboard[category][subCategory][module]["Unique Module ID"]
                const currentModuleId = dataSorterOrderDashboard[category][subCategory][module]["Current Module ID"]
                //const _order = orderOfAppearanceDashboard;//dataSorterOrderDashboard[category][subCategory][module]["Order of appearance"]
                const _order = dataSorterOrderDashboard[category][subCategory][module]["Order of appearance"]
                const _sort = dataSorterOrderDashboard[category][subCategory][module]
                //console.log("GGG102624 uniqueModuleId", uniqueModuleId);
                //console.log("D110424 currentModuleId", currentModuleId);
                //console.log("D110424 flattenedModulesDashboard", flattenedModulesDashboard);
                //console.log("K102624 +++++++++++++++ _order", _order);
                let _flatModuleDataDashboard = {} as any;
                if (flattenedModulesDashboard[currentModuleId]){
                  _flatModuleDataDashboard = JSON.parse(JSON.stringify(flattenedModulesDashboard[currentModuleId]));
                  if (Object.keys(_flatModuleDataDashboard).length > 0){
                    //console.log("K102624 _flatModuleData",currentModuleId, _flatModuleDataDashboard);
                    Object.keys(_flatModuleDataDashboard).forEach((shape) => {
                      //console.log("K102624 ---------------",shape, _flatModuleDataDashboard[shape]);
                      Object.keys(_flatModuleDataDashboard[shape]).forEach((grouping) => {
                        //console.log("K102624 ---------------============",grouping, _flatModuleDataDashboard[shape][grouping]);
                        _flatModuleDataDashboard[shape][grouping] = _flatModuleDataDashboard[shape][grouping].map((variable:any) => {
                          //console.log("K102624 ---------------============!!!!!!!!!!",variable);
                          _sort["Category_"] = category;
                          _sort["SubCategory_"] = subCategory;
                          const variableCopyDashboard = { ...variable };
                          variableCopyDashboard.Order = _order;
                          variableCopyDashboard.Sort = _sort;
                          variableCopyDashboard.moduleId = cleanString(uniqueModuleId);
                          return variableCopyDashboard;
                        });
                      });
                    });
                    
                  }else{
                    console.log("K102624 MISSING ------------------------------------");
                    console.log("K102624 uniqueModuleId", uniqueModuleId);
                    console.log("K102624 currentModuleId", currentModuleId);
                    console.log("K102624 --------------------------------------------");
                  }
                }else{
                  console.log("K102624 MISSING ------------------------------------");
                  console.log("K102624 uniqueModuleId", uniqueModuleId);
                  console.log("K102624 currentModuleId", currentModuleId);
                  console.log("K102624 --------------------------------------------");
                }
                //console.log("D110424 _flatModuleData ~~~~~~~~~~~~~",currentModuleId, _flatModuleDataDashboard);
                if (makeHeaderDashboard){
                  makeHeaderDashboard = false;
                  //console.log("D110424 makeHeaderDS category",category);
                  //console.log("D110424 makeHeaderDS _flatModuleDataDashboard",_flatModuleDataDashboard);
                  let COPIED_flatModuleDataDashboard = JSON.parse(JSON.stringify(_flatModuleDataDashboard));
                  let NEW_flatModuleDataDashboard:any = {};
                  //console.log("D110424 makeHeaderDS COPIED_flatModuleDataDashboard",COPIED_flatModuleDataDashboard);
                  if (Object.keys(COPIED_flatModuleDataDashboard).length > 0) {
                    let COPY_COPYDashboard = [JSON.parse(JSON.stringify(COPIED_flatModuleDataDashboard[Object.keys(COPIED_flatModuleDataDashboard)[0]][Object.keys(COPIED_flatModuleDataDashboard[Object.keys(COPIED_flatModuleDataDashboard)[0]])[0]]))[0]];
                    COPY_COPYDashboard[0].Shape = "category header";
                    COPY_COPYDashboard[0].Order = "0";
                    COPY_COPYDashboard[0].Tract = "X";
                    COPY_COPYDashboard[0].CD = "X";
                    COPY_COPYDashboard[0].PUMA = "X";
                    COPY_COPYDashboard[0].NYC = "X";
                    COPY_COPYDashboard[0].POINT = "X";
                    COPY_COPYDashboard[0].Boro = "X";

                    NEW_flatModuleDataDashboard["Ungrouped"] = {"category header" : COPY_COPYDashboard};
                  }
                  //console.log("D110424 makeHeaderDS NEW_flatModuleData",NEW_flatModuleDataDashboard);
                  dataSorterOrderDashboard[category][subCategory][`${cleanString(category)}-header`] = NEW_flatModuleDataDashboard;
                }
                dataSorterOrderDashboard[category][subCategory][uniqueModuleId] = _flatModuleDataDashboard;
              });
            });
          });
          console.log("A112724 dataSorterOrderDashboard", dataSorterOrderDashboard);
          console.log("A112724 groupedDataDashboard", groupedDataDashboard);
          //console.log("D102524 _indicatorOptions", _indicatorOptions);
          let _unGroupedModulesDashboard = {} as any;
          const processArraysInJSONDashboard = (obj: any, callback: (arr: any[]) => void): void => {
            for (const key in obj) {
              if (Array.isArray(obj[key])) {
                // If the property is an array, execute the callback function on it
                callback(obj[key]);
              } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                // If the property is an object, recursively process it
                processArraysInJSONDashboard(obj[key], callback);
              }
            }
          };
      
          // Call the function on `dataSorterOrderDashboard` with a callback to log each array
          processArraysInJSONDashboard(dataSorterOrderDashboard, (arr) => {
            //console.log("AA112724 Array found:", arr);
            _unGroupedModulesDashboard[arr[0].moduleId] = arr;
            arr.forEach(item => {
              //console.log("C032825 Array item:", item);
              if (item.Module !== "not used"){
                let _item = { directive: "dashboard", data: item["VARIABLE_NAME"], directive_data: item["moduleId"], category: item.Sort.Category_, availableGeos: getAvailGeos(item) }
                _searchDataDB[`${item.Sort.Category_} - ${item["DISPLAY_NAME"]}`] 
                    ? _searchDataDB[`${item.Sort.Category_} - ${item["DISPLAY_NAME"]}`].push(_item)
                    : _searchDataDB[`${item.Sort.Category_} - ${item["DISPLAY_NAME"]}`] = [_item]
              }
            });
          });

          //console.log("F092524 _indicatorOptionsDashboard", _indicatorOptionsDashboard);
          //console.log("YYY102724 groupedDataDashboard", groupedDataDashboard);
          //console.log("AA112724 _searchDataDashboard",_searchDataDashboard);
          //DB TODO setSearchData(_searchDataDashboard);
          //DB TODO? setIndicatorOptions(_indicatorOptionsDashboard)
          //setGroupedModules(groupedData);
          setSearchData({
            "explorer":_searchData,
            "stories":_searchDataDS,
            "dashboard":_searchDataDB,
          });
          setLocked(true);
          console.log("A012325 groupedDataDashboard", groupedDataDashboard);
          console.log("A012325 dataSorterOrderDashboard", dataSorterOrderDashboard);
          setUnGroupedModulesDashboard({..._unGroupedModulesDashboard});
          setGroupedModulesDashboard({...dataSorterOrderDashboard});
        }
      }
    }
  }, [dataActive, isLoadingAllTabularData]);

  useEffect(() => {
    console.log("J011625 customDB", customDB);
    console.log("J011625 privateCustomDB", privateCustomDB);
    if (customDB) {
      setParsedCustomDB(parseCustomDB(customDB));
    }
    if (privateCustomDB) {
      setParsedCustomDB(parseCustomDB(privateCustomDB));
    }
  }, [customDB, privateCustomDB]);

  useEffect(() => {
    console.log("A011325 parsedCustomDB", parsedCustomDB);
    if (parsedCustomDB && !initiatedCustomDB && dataSorterDashboard && groupedModulesDashboard && unGroupedModulesDashboard) {
      console.log("B011325 parsedCustomDB", parsedCustomDB);
      console.log("B011325 initiatedCustomDB", initiatedCustomDB); 
      console.log("B011325 dataSorterDashboard", dataSorterDashboard);
      console.log("B011325 groupedModulesDashboard", groupedModulesDashboard);
      console.log("B011325 unGroupedModulesDashboard", unGroupedModulesDashboard);
      setInitiatedCustomDB(true);
      const newGroupedModulesDashboard = { ...groupedModulesDashboard };
      const newUnGroupedModulesDashboard = { ...unGroupedModulesDashboard };
      Object.keys(parsedCustomDB).forEach((moduleName) => {
        initiateDashboardModules(parsedCustomDB[moduleName], moduleName, customDB, newGroupedModulesDashboard, newUnGroupedModulesDashboard);
      });
      setGroupedModulesDashboard(newGroupedModulesDashboard);
      setUnGroupedModulesDashboard(newUnGroupedModulesDashboard);
    }
  }, [parsedCustomDB, dataSorterDashboard, groupedModulesDashboard, unGroupedModulesDashboard]);

  function initiateDashboardModules(indicators: any[], moduleName: string, _customDB: string, newGroupedModulesDashboard: any, newUnGroupedModulesDashboard: any) {

    console.log("E011325 customDB", customDB);
    console.log("E011325 _customDB", _customDB);
    console.log("E011325 indicators", indicators);
    console.log("E011325 parsedCustomDB", parsedCustomDB);
  
    
    //let customDBString = "";
    indicators.forEach((indicator, index) => {
      console.log("B011325 indicator", indicator);
      console.log("B011325 indicator.id", indicator.id);
      //customDBString = customDBString + indicator.id + ((index < indicators.length - 1 ) ? "*" : "");
      const category="Custom";
      const subCategory="remove me";
      const module = moduleName === "" ? "Custom" : moduleName;
      //const module = uniqueModuleName(moduleName === "" ? "Custom" : moduleName, new Set(Object.keys(parsedCustomDB || {})));
      moduleName = module;
      const sumTo100="Ungrouped";
      const shape="stat list";
      const _found = dataSorterDashboard.find((item: any) => item.VARIABLE_NAME === indicator);
      if (!_found) {
        console.warn("initiateDashboardModules: no sorter row found for indicator", indicator);
        return;
      }
      const data = {..._found};
      console.log("A011425 data", data);
      data["moduleId"] = module; //cleanString(module);
      console.log("B011325 data", data);
      let s = {
        CATEGORY: "",
        CATEGORY_1: "",
        Category_: "Custom",
        Color: data["Module Color"] ? data["Module Color"] : "pink",
        "Current Module ID": module,
        "Icon": "custom",
        "Module Title": module,
        "Order of appearance": index + 1,
        Style: "below",
        SubCategory_: "remove me",
        "Unique Module ID": module
      }
      data.Sort = s;
      data.Shape = shape;
      if (!newGroupedModulesDashboard[category]) {
      newGroupedModulesDashboard[category] = {};
      }
      if (!newGroupedModulesDashboard[category][subCategory]) {
      newGroupedModulesDashboard[category][subCategory] = {};
      }
      if (!newGroupedModulesDashboard[category][subCategory][module]) {
      newGroupedModulesDashboard[category][subCategory][module] = {};
      }
      if (!newGroupedModulesDashboard[category][subCategory][module][sumTo100]) {
      newGroupedModulesDashboard[category][subCategory][module][sumTo100] = {};
      }
      if (!newGroupedModulesDashboard[category][subCategory][module][sumTo100][shape]) {
      newGroupedModulesDashboard[category][subCategory][module][sumTo100][shape] = [];
      }
      if (!newGroupedModulesDashboard[category][subCategory][module][sumTo100][shape].some((item: any) => item.VARIABLE_NAME === data.VARIABLE_NAME)) {
        newGroupedModulesDashboard[category][subCategory][module][sumTo100][shape].push(data);
      }
      if (!newUnGroupedModulesDashboard[module]) {
        newUnGroupedModulesDashboard[module] = [];
      }
      if (!newUnGroupedModulesDashboard[module].some((item: any) => item.VARIABLE_NAME === data.VARIABLE_NAME)) {
        newUnGroupedModulesDashboard[module].push(data);
      }
    });
    console.log("B011325 newGroupedModulesDashboard", newGroupedModulesDashboard);
    console.log("B011325 newUnGroupedModulesDashboard", newUnGroupedModulesDashboard);
  }

  /* THIS DOESNT REALLY WORK PROPERLY
  const uniqueModuleName = (baseName: string, existingNames: Set<string>): string => {
    let newName = baseName;
    let counter = 2;
    while (existingNames.has(newName)) {
      newName = `${baseName} ${counter}`;
      counter++;
    }
    return newName;
  };*/

  function validateCustomConfig(indicators: any[], moduleName: string, _customDB: string) {
    console.log('J011625 indicators', indicators);
    console.log('J011625 moduleName', moduleName);
    console.log('J011625 _customDB', _customDB);
    console.log('J011625 parsedCustomDB', parsedCustomDB);
    let returnable = "";
    if (indicators.length === 0){
      returnable = returnable + "No indicators selected. ";
    }
    if (moduleName.trim() === ""){
      returnable = returnable + "Please name module. ";
    } else if (new Set(Object.keys(parsedCustomDB || {})).has(moduleName.trim())){
      returnable = returnable + "Choose a unique name. ";
    }
    return returnable;
  }

  function updateDashboardModules(indicators: any[], moduleName: string, _customDB: string) {
    console.log("A011225  unGroupedModulesDashboard", unGroupedModulesDashboard);
    console.log("A011225  groupedModulesDashboard", groupedModulesDashboard);
    console.log("A011225  dataSorterOrderDashboard", dataSorterOrderDashboard);
    console.log("A011225  dataSorterDashboard", dataSorterDashboard);
    console.log("A011225 indicators",indicators);
    console.log("A011225 dataActive", dataActive);
    console.log("A011225 allData", allData);
    const newGroupedModulesDashboard = { ...groupedModulesDashboard };
    const newUnGroupedModulesDashboard = { ...unGroupedModulesDashboard };
    if (indicators === null){
      // We are removing this moduls
      console.log("E011525 REMOVING moduleName", moduleName);
      console.log("E011525 REMOVING _customDB", _customDB);
      console.log("E011525 newGroupedModulesDashboard", newGroupedModulesDashboard);
      console.log("E011525 newUnGroupedModulesDashboard", newUnGroupedModulesDashboard);
      console.log("EE011525 parsedCustomDB", parsedCustomDB);
      console.log("E011525 customDB", customDB);
      let _customDBString = "";
      Object.keys(parsedCustomDB).forEach((module, index) => {
        console.log("EE011525 module", module);
        console.log("EE011525 index", index);
        if (module !== moduleName){
          let _sub = "";
          parsedCustomDB[module].forEach((indicator: any, index:number) => {
            _sub = _sub + indicator + ((index < parsedCustomDB[module].length - 1 ) ? "." : "");
          });
          _customDBString = _customDBString + (_customDBString === "" ? "" : "*") + module + "~" + _sub
        }
      });
      console.log("EE011525 _customDBString", _customDBString);
      onSetCustomDB(_customDBString);
      setPrivateCustomDB(_customDBString);
      if (newGroupedModulesDashboard.Custom && newGroupedModulesDashboard.Custom["remove me"]) {
        delete newGroupedModulesDashboard.Custom["remove me"][moduleName];
      }
      if (newUnGroupedModulesDashboard) {
        delete newUnGroupedModulesDashboard[moduleName];
      }
      
    }else{
      let _order = parsedCustomDB ? Object.keys(parsedCustomDB).length + 1 : 1;
      console.log("B011225 customDB", customDB);
      console.log("B011225 _customDB", _customDB);
      console.log("B011225 indicators", indicators);
      console.log("B011225 parsedCustomDB", parsedCustomDB);

      const category="Custom";
      const subCategory="remove me";
      
      const module = moduleName === "" ? "Custom" : moduleName;
      //const module = uniqueModuleName(moduleName === "" ? "Custom" : moduleName, new Set(Object.keys(parsedCustomDB || {})));
      moduleName = module;
      const sumTo100="Ungrouped";
      const shape="stat list";
      console.log("F011325 module", module);
      console.log("F011325 indicators", indicators);
      let customDBString = "";
      indicators.forEach((indicator, index) => {
        console.log("A011225 indicator", indicator);
        console.log("B011225 indicator.id", indicator.id);
        customDBString = customDBString + indicator.id + ((index < indicators.length - 1 ) ? "." : "");

        const data = JSON.parse(JSON.stringify(dataSorterDashboard.find((item: any) => item.VARIABLE_NAME === indicator.id)));

        data["moduleId"] = module; //cleanString(module);
        console.log("A011225 data", data);
      
        let s = {
          CATEGORY: "",
          CATEGORY_1: "",
          Category_: "Custom",
          Color: data["Module Color"] ? data["Module Color"] : "pink",
          "Current Module ID": module,
          "Icon": "custom",
          "Module Title": module,
          "Order of appearance": _order,
          Style: "below",
          SubCategory_: "remove me",
          "Unique Module ID": module
        }
        data.Sort = s;
        data.Shape = shape;
        if (!newGroupedModulesDashboard[category]) {
        newGroupedModulesDashboard[category] = {};
        }
        if (!newGroupedModulesDashboard[category][subCategory]) {
        newGroupedModulesDashboard[category][subCategory] = {};
        }
        if (!newGroupedModulesDashboard[category][subCategory][module]) {
        newGroupedModulesDashboard[category][subCategory][module] = {};
        }
        if (!newGroupedModulesDashboard[category][subCategory][module][sumTo100]) {
        newGroupedModulesDashboard[category][subCategory][module][sumTo100] = {};
        }
        if (!newGroupedModulesDashboard[category][subCategory][module][sumTo100][shape]) {
        newGroupedModulesDashboard[category][subCategory][module][sumTo100][shape] = [];
        }
        newGroupedModulesDashboard[category][subCategory][module][sumTo100][shape].push(data);
        if (!newUnGroupedModulesDashboard[module]) {
          newUnGroupedModulesDashboard[module] = [];
        }
        newUnGroupedModulesDashboard[module].push(data);
      });
      customDBString = moduleName + "~" + customDBString;
      //customDBString = cleanString(moduleName) + "~" + customDBString;
      console.log("F011325 _customDB", _customDB);
      console.log("F011325 customDB", customDB);
      console.log("F011325 customDBString", customDBString);
      let fullCustomDBString = _customDB === "" ? customDBString : _customDB + "*" + customDBString;
      //onSetCustomDB(fullCustomDBString)
      console.log("F011325 fullCustomDBString", fullCustomDBString);
      onSetCustomDB(fullCustomDBString);
      setPrivateCustomDB(fullCustomDBString);
    }
    console.log("F011525 newGroupedModulesDashboard", newGroupedModulesDashboard);
    console.log("F011525 newUnGroupedModulesDashboard", newUnGroupedModulesDashboard);
    setGroupedModulesDashboard(newGroupedModulesDashboard);
    setUnGroupedModulesDashboard(newUnGroupedModulesDashboard);
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 950);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    console.log("L092924 groupedModules",groupedModules);
  }, [groupedModules]);
  // Function to change page and preserve other parameters in order

  const changePage = (newPage: string) => {
    const newSearchParams = new URLSearchParams(location.search);
    //newSearchParams.set('page', newPage); // Update the 'page' parameter
    onSetActivePage(newPage);
    // Construct the URL with parameters in the correct order
    const paramsOrder = ['page', 'lat', 'lng', 'zoom', 'selectedId', 'activeGeography', 'activeIndicator', 'bivariateIndicator'];
    const orderedParams = new URLSearchParams();
    
    paramsOrder.forEach(param => {
      const value = newSearchParams.get(param);
      if (value) orderedParams.set(param, value);
    });

    navigate(`/?${orderedParams.toString()}`, { replace: true });
    toggleMenu(); // Close the menu
  };
  //console.log("Z031025 groupedModulesStories", groupedModulesStories);
  return (
    <>     
      <div className="top-navbar">      
        <div className="menu-toggle" onClick={() => changePage('menu')}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
        { siteConfig.ctx === 'nyc' 
          ? <img src={MoALogo} alt="Measure of America" className="moa-logo" />
          : <img src={SCBLogo} alt="Cottage Data2Go" className="sbc-logo" />
        }
        <div className="navbar-title">{siteConfig.ctx === 'nyc' ? <>DATA2GO.<b>NYC</b></> : <>Cottage <b><i>Data2Go</i></b></>}</div>
        {isMobile 
          ? <></>
          : <div className="magnify-search-button" onClick={() => changePage('search')}>
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18.3337" cy="11.6667" r="9.91667" fill="none" stroke="black" strokeWidth="3.5" />
                <path d="M2 28.0001L11.3333 18.6667" stroke="black" strokeWidth="3.5" strokeLinecap="round" />
              </svg>
            </div>}
      </div>
      <div className="sidebar">
        {isMobile 
          ? <div style={{ padding: '10px', paddingTop: '25px' }}>For the full DATA2GO.<b>NYC</b> experience, visit on a desktop or larger tablet.</div>
          : <ul className="nav-links">
              <li className="nav-links-li" style={{fontWeight: currentPage === "explorer" ? "bold" : "normal"}} onClick={() => changePage('explorer')}>STAT EXPLORER</li>
              <li className="nav-links-li" style={{fontWeight: currentPage === "dashboard" ? "bold" : "normal"}} onClick={() => changePage('dashboard')} dangerouslySetInnerHTML={{__html: siteConfig.nav.dashboardLabel}} />
              {siteConfig.nav.demographicExplorer && <li className="nav-links-li" style={{fontWeight: currentPage === "rg" ? "bold" : "normal"}} onClick={() => changePage('rg')}>DEMOGRAPHIC<br/>EXPLORER</li>}
              <li className="nav-links-li" style={{fontWeight: currentPage === "compare" ? "bold" : "normal"}} onClick={() => changePage('compare')}>COMPARISONS</li>
              <li className="nav-links-li" style={{fontWeight: currentPage === "stories" ? "bold" : "normal"}} onClick={() => changePage('stories')}>DATA STORIES</li>
              <li className="nav-links-li" style={{fontWeight: "normal"}} onClick={() => window.open('/D2G FAQ_2025-04-29.pdf', '_blank')}>FAQ</li>
              <li className="nav-links-li" style={{fontWeight: "normal"}} onClick={() => setShowAbout(true)}>ABOUT US</li>
            </ul>
        }
        <div
          style={{
            height: '100%',
            display: 'inline-flex',
            flexDirection: 'column',
            alignContent: 'stretch',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginBottom: '30px',
          }}
        >
          <a href='https://measureofamerica.org/' target='_blank'>
            <img
              src={moa_logo}
              alt="Measure of America Logo"
              style={{ width: "auto", height: "67.5px", marginBottom: '20px' }}
            />
          </a>
          { siteConfig.ctx === 'nyc' &&
          <a href='https://helmsleytrust.org/' target='_blank'>
            <img
              src={helmsley_logo}
              alt="Helmsley Charitable Trust Logo"
              style={{ width: "auto", height: "60px" }}
            />
          </a>
          }
        </div>
      </div>
      <Routes>
        <Route path="/" element={isMobile ? (
          <MobileView
            key={`Mobile-${activeGeography}`}
            handleChildReady={handleChildReady}
            indicatorOptions={indicatorOptions}
            groupedModules={groupedModules}
            unGroupedModules={unGroupedModules}
            //activeGeography={activeGeography}
            allData={allData}
            moduleIdIncrement={moduleIdIncrement}
            updateDashboardModules={updateDashboardModules}
            validateCustomConfig={validateCustomConfig}
            setModuleIdIncrement={setModuleIdIncrement}
          />
        ) 
        : currentPage === 'rg' 
        ? <RaceAndGender
            key={`Race-Gender-${activeGeography}`}
            handleChildReady={handleChildReady}
            indicatorOptions={indicatorOptions}
            groupedModules={groupedModulesRG}
            unGroupedModules={unGroupedModulesRG}
            activeGeography={activeGeography}
            allData={allData}
            moduleIdIncrement={moduleIdIncrement}
            updateDashboardModules={updateDashboardModules}
            validateCustomConfig={validateCustomConfig}
            setModuleIdIncrement={setModuleIdIncrement}
        /> 
        : currentPage === 'explorer' 
        ? <StatExplorer
            key={`Stat-Explorer-${activeGeography}`}
            handleChildReady={handleChildReady}
            indicatorOptions={indicatorOptions}
            groupedModules={groupedModules}
            unGroupedModules={unGroupedModules}
            activeGeography={activeGeography}
            allData={allData}
            moduleIdIncrement={moduleIdIncrement}
            updateDashboardModules={updateDashboardModules}
            validateCustomConfig={validateCustomConfig}
            setModuleIdIncrement={setModuleIdIncrement}
        /> 
        : currentPage === 'dashboard' 
        ? <Dashboards
            key={`Stat-Explorer-${activeGeography}`}
            handleChildReady={handleChildReady}
            indicatorOptions={indicatorOptions}
            groupedModules={groupedModulesDashboard}
            unGroupedModules={unGroupedModulesDashboard}
            activeGeography={activeGeography}
            allData={allData}
            moduleIdIncrement={moduleIdIncrement}
            updateDashboardModules={updateDashboardModules}
            validateCustomConfig={validateCustomConfig}
            setModuleIdIncrement={setModuleIdIncrement}
        /> 
        : currentPage === 'compare'  
        ? <Comparisons
            key={`Comparisons-${activeGeography}`}
            handleChildReady={handleChildReady}
            indicatorOptions={indicatorOptions}
            groupedModules={groupedModules}
            unGroupedModules={unGroupedModules}
            activeGeography={activeGeography}
            allData={allData}
        />
        : <DataStories
          key={`Data-stories-${activeGeography}`}
          handleChildReady={handleChildReady}
          indicatorOptions={indicatorOptions}
          groupedModules={groupedModulesStories}
          unGroupedModules={unGroupedModulesStories}
          activeGeography={activeGeography}
          allData={allData}
          storySelected={storySelected}
          setStorySelected={setStorySelected}
          moduleIdIncrement={moduleIdIncrement}
          updateDashboardModules={updateDashboardModules}
          validateCustomConfig={validateCustomConfig}
          setModuleIdIncrement={setModuleIdIncrement}
          setShowBackToStories={setShowBackToStories}
      /> 
        } />
      </Routes>
    </>
  );
}

function App() {
  const [display, setDisplay] = useState<string>("menu"); // menu, search
  const [resultsToDisplay, setResultsToDisplay] = useState<boolean>(false); // Controls search results display
  const [displayContext, setDisplayContext] = useState<string>("closed"); // closed, menuOpen, searchOpen
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false); // Control fullscreen search popup
  const [indicatorOptions, setIndicatorOptions] = useState<any | null>(null);
  const [groupedModules, setGroupedModules] = useState<any | null>(null);
  const [groupedModulesRG, setGroupedModulesRG] = useState<any | null>(null);
  const [unGroupedModules, setUnGroupedModules] = useState<any | null>(null);
  const [unGroupedModulesRG, setUnGroupedModulesRG] = useState<any | null>(null);
  const [groupedModulesStories, setGroupedModulesStories] = useState<any | null>(null);
  const [unGroupedModulesStories, setUnGroupedModulesStories] = useState<any | null>(null);
  const [groupedModulesDashboard, setGroupedModulesDashboard] = useState<any | null>(null);
  const [unGroupedModulesDashboard, setUnGroupedModulesDashboard] = useState<any | null>(null);
  const [searchData, setSearchData] = useState<any>(null);
  const [allData, setAllData] = useState<any | null>(null);
  const [moduleIdIncrement, setModuleIdIncrement] = useState<number>(0);
  const [lockOut, setLockOut] = useState<boolean>(false);
  const [showSplash, setShowSplash] = useState<boolean>(false);
  const [showAbout, setShowAbout] = useState<boolean>(false);
  const [showBackToStories, setShowBackToStories] = useState<boolean>(false);
  const [storySelected, setStorySelected] = useState<string>(siteConfig.defaultStory);
  const [showSpreadOut, setShowSpreadOut] = useState<boolean>(window.innerWidth < 1011 && window.innerWidth > 950);
  // useRef to ensure we only run the sessionStorage check once
  const hasCheckedStorage = useRef(false);

  useEffect(() => {
    if (!hasCheckedStorage.current) {
      hasCheckedStorage.current = true;
      try {
        if (typeof window !== 'undefined' && window.sessionStorage) {
          const hasVisited = sessionStorage.getItem('hasVisited') === 'true';
          if (!hasVisited) {
            sessionStorage.setItem('hasVisited', 'true');
          }
          // Show splash only if the user hasn't visited yet
          setShowSplash(!hasVisited);
        } else {
          // Fallback to show splash if sessionStorage isn't available
          setShowSplash(true);
        }
      } catch (error) {
        console.warn('Session storage is not available. Using fallback.');
        setShowSplash(true);
      }
    }
  }, []);
  
  const activeGeography = useGlobalActiveGeography();
  const selectedId = useGlobalSelectedId();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);
  const toggleMenu = () => {
    // Using state variables in the return for this component will cause costly re-renders, 
    // lets do it the old-fashioned way here.
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      setDisplay(displayContext === "closed" ? "menu" : display);
      setDisplayContext(displayContext === "closed" ? "menuOpen" : "closed");
      mainContent.classList.toggle('show-menu'); // Toggle the 'show-menu' class directly
    }
  };

  const goBackToStories = () => {
    console.log("100726 Go back to stories");
    // Reset geography to the site default before navigating back so that
    // stories beeswarms (Place/CD-only data) don't crash when they render
    // with a Tract selectedId that isn't in their dataJSON.
    // onSetActiveGeography fires synchronously; onSetActivePage is debounced(0ms)
    // so it enqueues on the next tick — geography swap always lands first.
    onSetActiveGeography(siteConfig.defaults.activeGeography);
    onSetActivePage("stories");
    setShowBackToStories(false);
  };

  useLayoutEffect(() => {
    // This function runs after all child components have rendered
    console.log("100424 all components rendered selectedId", selectedId)
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 950){
        onSetActiveGeography("CD");
      }else{

      }
      setIsMobile(window.innerWidth < 950);
      setShowSpreadOut(window.innerWidth < 1011 && window.innerWidth > 950);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    console.log("100124 isMobile", isMobile);
    if (isMobile){
      onSetActiveGeography("CD");
    }else{

    }
  }, [isMobile]);

  useEffect(() => {
    console.log("100124 selectedId",selectedId);
  }, [selectedId]);

  const toggleSearchPopup = () => {
    console.log('Search button clicked');
    setIsSearchOpen(!isSearchOpen); // Toggle fullscreen popup
  };

  const closeSearchPopup = () => {
    setIsSearchOpen(false); // Close the popup
  };
  
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'f') {
        event.preventDefault(); // Prevent the default browser search
        toggleSearchPopup();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <DataProvider title="NYC Data2Go">
      <Router>
        {/* Ensure all components using Router hooks are within the Router context */}
        <div className="top-navbar">
          <div className="menu-toggle" onClick={toggleMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
            <a href='/' style={{ textDecoration: 'none', color: 'inherit', width: '485px' }}>
            <div>
              { siteConfig.ctx === 'nyc' 
                ? <img src={MoALogo} alt="Measure of America" className="moa-logo" />
                : <img src={SCBLogo} alt="Cottage Data2Go" className="sbc-logo" />
              }
            </div>
            <div className="navbar-title">{siteConfig.ctx === 'nyc' ? <>DATA2GO.<b>NYC</b></> : <>Cottage <b><i>Data2Go</i></b></>}</div>
            </a>
          <div className="header-message-center">
            <div className="exporting-spinner off" id='exportingSpinner'>
              Exporting.
              <div className="export-spinner">
                <FontAwesomeIcon icon={faSpinner} spin />
              </div>`
            </div>
          </div>
          {isMobile 
          ? <></>
          : <div className="magnify-search-button"
              onClick={() => {
                console.log('Search button clicked'); // Logging button click for debug
                toggleSearchPopup();
              }}
            >
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="18.3337" cy="11.6667" r="9.91667" fill="none" stroke="black" strokeWidth="3.5" />
              <path d="M2 28.0001L11.3333 18.6667" stroke="black" strokeWidth="3.5" strokeLinecap="round" />
            </svg>
          </div>}
        </div>
        <BackToStoriesButton 
          goBack={goBackToStories}
          isOpen={showBackToStories}
        />
        <SplashScreen
          isOpen={showSplash}
          onClose={() => setShowSplash(false)}
          setShowAbout={setShowAbout}
        /> 
        <AboutScreen
          isOpen={showAbout}
          onClose={() => setShowAbout(false)}
        /> 
        <SpreadOutScreen
          isOpen={showSpreadOut}
          onClose={() => setShowSpreadOut(false)}
        /> 
        <div className={`main-content`}>
          {/* Fullscreen Search Popup */}
          <SearchPopup 
            isOpen={isSearchOpen} 
            onClose={toggleSearchPopup} 
            searchDataAllPages={searchData}
            groupedModules={groupedModules}
            allData={allData}
            setModuleIdIncrement={setModuleIdIncrement}
            moduleIdIncrement={moduleIdIncrement}
          />
          <Navigation   
            setShowAbout={setShowAbout}  
            searchData={searchData}
            setSearchData={setSearchData}    
            indicatorOptions={indicatorOptions}
            groupedModules={groupedModules}
            groupedModulesRG={groupedModulesRG}
            groupedModulesDashboard={groupedModulesDashboard}
            groupedModulesStories={groupedModulesStories}
            unGroupedModules={unGroupedModules}
            unGroupedModulesRG={unGroupedModulesRG}
            unGroupedModulesDashboard={unGroupedModulesDashboard}
            unGroupedModulesStories={unGroupedModulesStories}
            allData={allData}
            setAllData={setAllData}
            setGroupedModules={setGroupedModules}
            setUnGroupedModules={setUnGroupedModules}
            setGroupedModulesRG={setGroupedModulesRG}
            setUnGroupedModulesRG={setUnGroupedModulesRG}
            setGroupedModulesDashboard={setGroupedModulesDashboard}
            setUnGroupedModulesDashboard={setUnGroupedModulesDashboard}
            setGroupedModulesStories={setGroupedModulesStories}
            setUnGroupedModulesStories={setUnGroupedModulesStories}
            setIndicatorOptions={setIndicatorOptions}
            setModuleIdIncrement={setModuleIdIncrement}
            moduleIdIncrement={moduleIdIncrement}
            toggleMenu={toggleMenu}
            setShowBackToStories={setShowBackToStories}
            showBackToStories={showBackToStories}
            storySelected={storySelected}
            setStorySelected={setStorySelected}
          /> {/* Navigation is within the Router */}
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
